import React, { useState } from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { barIcon, pieIcon } from '@/pages/opinion/constants/chart';
import PieEchart from './PieEchart';
import BarLineEchart from './BarLineEchart';
import { useIntl } from 'umi';
import { NO_DATE } from '@/pages/opinion/constants';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';

export default function PurchaseAnalysisChart({
  pieChartData = [],
  timelineChartData = [],
  title = '',
  tipsMap = null,
  filter,
}: any) {
  const [chartType, setChartType] = useState<'bar' | 'pie'>('bar');
  const { formatMessage } = useIntl();
  return (
    <CardCommon
      title={
        <>
          {formatMessage({ id: title || NO_DATE.EMPTY })}
          <BubbleCommon
            placement="top"
            childStyle={{ verticalAlign: 'middle' }}
            tipsMap={tipsMap}
          ></BubbleCommon>
        </>
      }
      contentCard
      defaultOperation={chartType}
      operations={[barIcon, pieIcon]}
      handleOperationsOnClick={({ symbol }: any) => setChartType(symbol)}
    >
      <>
        {chartType === 'bar' ? (
          <BarLineEchart
            data={timelineChartData}
            filter={filter}
          ></BarLineEchart>
        ) : (
          <PieEchart chartData={pieChartData} pieLabelAlignTo></PieEchart>
        )}
      </>
    </CardCommon>
  );
}
